import { memo } from 'react'
import { CircularProgress } from '@mui/material'
import { Box } from '@/components/Layout'
import { spinnerStyles as styles } from './Spinner.style'
import { SpinnerProps } from './Spinner.types'

const defaultSpinnerSize = {
  size: 18,
  thickness: 4,
}

function Spinner(props: SpinnerProps) {
  return (
    <Box sx={styles.wrapper}>
      <CircularProgress
        variant="determinate"
        sx={styles.back}
        value={100}
        {...defaultSpinnerSize}
        {...props}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        value={10}
        sx={styles.front}
        {...defaultSpinnerSize}
        {...props}
      />
    </Box>
  )
}

export default memo(Spinner)
